import { LOGO_URL } from '../common/constants';

let cachedLogoBase64 = null;

export const getLogoBase64 = async () => {
  if (cachedLogoBase64) return cachedLogoBase64;

  // Método robusto: Descarga directa como Blob y conversión a Base64.
  // Evita problemas de "Canvas Tainting" y respeta URLs firmadas.
  const fetchAsBase64 = async (url) => {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP Error: ${response.status}`);
    const blob = await response.blob();
    
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };

  try {
    // 1. Intento directo exacto a la URL (Sin alterar parámetros)
    cachedLogoBase64 = await fetchAsBase64(LOGO_URL);
    return cachedLogoBase64;
  } catch (error) {
    console.warn("Fallo la obtención directa del logo, intentando mediante proxy...", error);
    
    try {
      // 2. Fallback usando un proxy en caso de restricciones CORS severas
      const proxyUrl = `https://api.allorigins.win/raw?url=${encodeURIComponent(LOGO_URL)}`;
      cachedLogoBase64 = await fetchAsBase64(proxyUrl);
      return cachedLogoBase64;
    } catch (proxyError) {
      console.error("Fallo definitivo al cargar el logo:", proxyError);
      throw proxyError;
    }
  }
};